<template>
    <configReposicionFile @refrest="close"/>
</template>

<script>
import { mapActions } from 'vuex';
import configReposicionFile from './configReposicionFile.vue';

export default {
    name: "config-reposicion-options",
    components: {
        configReposicionFile,
    },
    methods: {
        ...mapActions(["executeCommit"]),
        close() {
            this.executeCommit({
                mutation: "close_modal",
            });
            this.$emit("refrest");
        }
    }
};
</script>


